var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import mergeThemes from '../../lib/mergeThemes';
import base from '../base';
import * as siteVariables from './siteVariables';
import * as componentVariables from './componentVariables';
import * as componentStyles from './componentStyles';
import fontFaces from './fontFaces';
import staticStyles from './staticStyles';
import { default as svgIconsAndStyles } from './components/Icon/svg';
import { default as fontIcons } from './components/Icon/font';
var declareSvg = function (svgIcon) { return ({
    isSvg: true,
    icon: svgIcon,
}); };
var declareFontBased = function (fontIcon) { return ({ icon: fontIcon }); };
var icons = Object.keys(svgIconsAndStyles).reduce(function (accIcons, iconName) {
    var _a;
    var iconAndMaybeStyles = svgIconsAndStyles[iconName];
    var icon = iconAndMaybeStyles.styles
        ? iconAndMaybeStyles.icon
        : iconAndMaybeStyles;
    return __assign({}, accIcons, (_a = {}, _a[iconName] = declareSvg(icon), _a));
}, {});
Object.keys(fontIcons).forEach(function (iconName) {
    icons[iconName] = declareFontBased(fontIcons[iconName]);
});
export default mergeThemes(base, {
    siteVariables: siteVariables,
    componentVariables: componentVariables,
    componentStyles: componentStyles,
    fontFaces: fontFaces,
    staticStyles: staticStyles,
    icons: icons,
});
